// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyFilledSvg from "@fishx/icons-svg/es/asn/CopyFilled";
import FishxIcon from '../components/FishxIcon';

var CopyFilled = function CopyFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyFilledSvg
  }));
};

CopyFilled.displayName = 'CopyFilled';
export default React.forwardRef(CopyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyFilled.js
// module id = 2321
// module chunks = 0